import { render, staticRenderFns } from "./CreateOrEditGoods.vue?vue&type=template&id=0072e687&scoped=true&"
import script from "./CreateOrEditGoods.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditGoods.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrEditGoods.vue?vue&type=style&index=0&id=0072e687&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0072e687",
  null
  
)

export default component.exports